import { Link } from "react-router-dom";
import { CATEGORIES } from "@/lib/api";

const ctaBase = "px-6 py-3 border-2 border-black font-mono-data uppercase text-sm hard-shadow-hover no-underline hover:no-underline";

function SiteStats({ totalListings }) {
  const rows = [
    ["Total Listings", totalListings ?? "—", ""],
    ["Categories", CATEGORIES.length, ""],
    ["Active Today", "●  LIVE", "text-[#008800]"],
  ];
  return (
    <div className="md:col-span-4 border-2 border-black p-4 bg-[#F9F9F9]">
      <div className="font-mono-data text-xs uppercase border-b border-black pb-2 mb-3">SITE STATS</div>
      <dl className="space-y-2 font-mono-data text-sm">
        {rows.map(([label, value, cls]) => (
          <div key={label} className="flex justify-between"><dt>{label}</dt><dd className={`font-bold ${cls}`}>{value}</dd></div>
        ))}
      </dl>
    </div>
  );
}

export function Hero({ totalListings }) {
  return (
    <section className="border-b-2 border-black bg-white">
      <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-10 md:py-16 grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
        <div className="md:col-span-8">
          <div className="font-mono-data text-xs uppercase border border-black inline-block px-2 py-1 mb-4">EST. 2026 — MARKETCRAIG.</div>
          <h1 className="font-display text-5xl md:text-7xl lg:text-8xl uppercase leading-[0.9] tracking-tighter">
            Buy. Sell.<br />
            <span className="text-[#0000EE]">Negotiate.</span>
          </h1>
          <p className="font-mono-data text-sm uppercase mt-6 text-gray-700 max-w-xl">
            A straightforward classifieds board. Cars, jobs, apartments, gadgets — all in one place. List free, message instantly, deal direct.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link to="/post" data-testid="hero-post-cta" className={`${ctaBase} bg-black text-white hover:bg-[#0000EE] hover:border-[#0000EE]`}>+ Post an Ad</Link>
            <Link to="/category/vehicles" data-testid="hero-browse-cta" className={`${ctaBase} bg-white text-black hover:bg-yellow-100`}>Browse Vehicles →</Link>
          </div>
        </div>
        <SiteStats totalListings={totalListings} />
      </div>
    </section>
  );
}
